(ns rothko.panel-modal.component
  (:require [rothko.component.core :refer [defcomp]]
            [rothko.icon.component :refer [icon]]
            [rothko.modal.component :refer [modal]]
            [rothko.panel.component :refer [panel]]))

(defcomp panel-modal
  {:type ::panel-modal}
  [{:keys [dismissable? on-close title] :as props} & children]
  [modal props
   [panel {:class [:panel-modal__panel]
           :appearance #{:primary}}
    [:div.panel-modal__panel-content
     (when title [:h5 title])
     (into [:<>] children)
     (when dismissable?
       [icon {:icon :cross
              :size 15
              :on-click #(on-close)}])]]])
